const user = axios => {
	return {
		async Login(data) {
			return axios.post("/api/auth/signin", data)
		}
	}
}

export default user;
